import { helpers } from 'vuelidate/lib/validators'

// override the default numeric validator to allow floats
export const numeric = helpers.regex('numeric', /^[0-9]+(\.[0-9]+)?$/);

export default {
    methods: {

        touchField(index, field) {
            const boxes = this.$v && this.$v.boxes && this.$v.boxes.$each;
            if (boxes && boxes[index] && boxes[index][field]) {
              boxes[index][field].$touch();
              this.emitValidationState();
            }
        },

        getErrorMessage(index, field) {
            const boxes = this.$v && this.$v.boxes && this.$v.boxes.$each;
            if (!boxes || !boxes[index] || !boxes[index][field]) {
                return '';
            }

            const fieldValidation = boxes[index][field];
            if (!fieldValidation.$dirty) return '';

            let errorMessage = '';
            errorMessage = fieldValidation.required !== undefined && !fieldValidation.required ? `${field.charAt(0).toUpperCase() + field.slice(1)} is required.` : errorMessage;
            errorMessage = fieldValidation.numeric !== undefined && !fieldValidation.numeric ? `${field.charAt(0).toUpperCase() + field.slice(1)} is not a number.` : errorMessage;
            errorMessage = fieldValidation.integer !== undefined && !fieldValidation.integer ? `${field.charAt(0).toUpperCase() + field.slice(1)} is not an integer.` : errorMessage;

            return errorMessage;
        },

        validate() {
            if (this.$v) {
                this.$v.$touch();
                this.emitValidationState();
            }
        },

        emitValidationState() {

            if (!this.$v || !this.$v.boxes || !this.$v.boxes.$each) {
                this.$emit('validation-state', false); // Assume invalid if validation is missing
                return;
            }

            const hasErrors = Object.keys(this.$v.boxes.$each).some(index => {
                const box = this.$v.boxes.$each[index];
                return box && Object.keys(box).some(field => {
                    const fieldValidation = box[field];
                    return fieldValidation && fieldValidation.$dirty && fieldValidation.$invalid;
                });
            });

            this.$emit('validation-state', !hasErrors);
        },

        getValidationRules() {
            return this.$options.validations.boxes.$each || {}
        }
    }
}